import axios from "axios";

export const createDemoRequest = async (email: string, firstName: string, lastName: string, companyName: string, telephone: string) => {
  const headers = {
    "Access-Control-Expose-Headers": "Access-Control-Allow-Origin",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const data = {
    TableName: "demoRequests",
    Item: { email: email, firstName: firstName, lastName: lastName, companyName: companyName, telephone: telephone },
  };
  await axios
    .post("https://d222hu8pcowl39.cloudfront.net/default/querying", data, {
      headers,
    })
    .catch((e) => console.log(e));
};